import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Grid } from '@mui/material'
import { Assignment, Flag } from '@mui/icons-material'

import { useGET_assignmentsQuery } from 'redux/api/assignmentsApi'
import BoxTitle from 'components/atoms/BoxTitle'
import { useTableModel } from 'utils/tableModels/useAssignmentsTableModel'
import Table from './Table'

const Assignments: FC = () => {
  const { t } = useTranslation()

  const { data } = useGET_assignmentsQuery({
    page: 1,
    page_size: 5,
    ordering: '-due_datetime'
  })

  return (
    <Box className="dashboard-page-section-box"><div className='dashboard-section-padding'>
      <Grid container spacing={2}>
        <Grid item xs={12} xl={12}>

          <Grid container spacing={1}>
              <Grid item xs={8}>
                <BoxTitle title={t('common.assignments')} icon={<Assignment />} />
              </Grid>

              <Grid item xs={4} textAlign={'right'}>
                <Button
                      variant='outlined'
                      color='black'
                      onClick={() => window.location.href = '/assignments'}
                      className='small-button'
                    >
                      {`${t('common.view-all')}`}
                </Button>

                <Button sx={{ marginLeft: '10px' }}
                      variant='contained'
                      color='primary'
                      onClick={() => window.location.href = '/assignments/add'}
                      className='small-button'
                    >
                      {`${t('common.add-assignment')}`}
                </Button>
              </Grid>
          </Grid>

          <Grid item xs={12} sx={{ marginTop: '20px' }}>
            <Table useTableModel={useTableModel} data={data?.results} />
          </Grid>
        </Grid>
      </Grid>
    </div></Box>
  )
}

export default Assignments
